// Deterministic id-only hashes for provenance manifests (not cryptographic secrets).

export function hashString(input: string): string {
  let h = 2166136261;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

export function hashAnswerValue(questionId: string, value: unknown): string {
  const payload = `${questionId}:${JSON.stringify(value ?? null)}`;
  return hashString(payload);
}
